




















































import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class DadosPaciente extends Vue {
  @Prop()
  paciente!: any;

  mounted() {
   console.log(this.paciente); 
  }
}
